import styled from 'styled-components';

export const S_ChartWrapper = styled.div`
  width: 500px;
  height: 450px;

  @media screen and (max-width: 700px) {
    width: 100%;
    height: 300px;
  }
`;
